import { breakpoints } from '../constants';
import { BreakpointType } from '../types';

export const forceRefresh = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('nocache', new Date().getTime().toString());
  location.href = url.toString();
};
const getCurrentBreakpoint = (): BreakpointType | null => {
  if (typeof window === 'undefined') return null;

  const entries = Object.entries(breakpoints) as [BreakpointType, string][];
  for (const [name, query] of entries) {
    if (window.matchMedia(query).matches) {
      return name;
    }
  }
  return null;
};
export const getDeviceMetrics = () => {
  const breakpoint = getCurrentBreakpoint();

  return {
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    device_pixel_ratio: Number(window.devicePixelRatio.toFixed(1)),
    browser_scale_ratio: Number((window.outerWidth / window.innerWidth).toFixed(1)),
    breakpoint: breakpoint ?? 'unknown',
  };
};
